// extracted by mini-css-extract-plugin
module.exports = {"container":"Bars_container__2A6FN","row":"Bars_row__2yE0D","label":"Bars_label__23Y96","bar-container":"Bars_bar-container__2pTq8","bar":"Bars_bar__2Ynqj"};